










import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({
    name: 'LanguageChooser',
    components: {},
})
export default class LanguageChooser extends Vue {
    private localeValue: string = 'de';

    @Getter('utils/currentLocale') private currentLocale: string;

    private mounted() {
        this.$i18n.locale = this.currentLocale;
        this.localeValue = this.currentLocale;
    }

    private changeLanguage(localeValue) {
        // Update the locale value in the i18n environment
        this.$i18n.locale = localeValue;

        // Commit them in the store
        this.$store.commit('utils/setCurrentLocale', localeValue);
    }

    private activeClass(locale) {
        return this.currentLocale === locale ? 'locale-link-active' : '';
    }
}
